import CodingEntityDropdown from 'app/pages/overview/tabs/transactions/CodingEntityDropdown';
import { useMemo } from 'react';
import { AgaveSubJob } from 'API';
import { Box, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AgaveSubJobsDropdownProps {
  disabled?: boolean;
  disableHeader?: boolean;
  selectedSubJob?: AgaveSubJob | null;
  onValueChange: (option: AgaveSubJob | null) => void;
  selectedProjectId?: string | null;
  placeholder?: string | null;
  enabled?: boolean;
  /** Load options only when dropdown opens (use in table rows to avoid stale shared state). */
  fetchOnlyOnOpen?: boolean;
}

const AgaveSubJobsDropdown = ({
  disabled,
  disableHeader = true,
  selectedSubJob,
  onValueChange,
  selectedProjectId,
  placeholder,
  enabled = true,
  fetchOnlyOnOpen,
}: AgaveSubJobsDropdownProps) => {
  const { t } = useTranslation();

  // Disable if no project is selected
  const isDisabled = useMemo(() => disabled || !selectedProjectId, [disabled, selectedProjectId]);

  return (
    <Tooltip
      title={
        !selectedProjectId
          ? t(
              'transactionSidesheet.subJobRequiresProjectTooltip',
              'A project must be selected to assign a sub job'
            )
          : ''
      }
      arrow
      placement="top"
    >
      <Box sx={{ width: '100%' }}>
        {/* SEE-1207 (logged in SEE-1056): identifierField is `code` — sub-job
            rows populate `code`, never `number`; pointing at number rendered
            name-only labels. */}
        <CodingEntityDropdown<AgaveSubJob>
          entityType="subJobs"
          selectedItem={selectedSubJob}
          onValueChange={onValueChange}
          disabled={isDisabled}
          disableHeader={disableHeader}
          placeholder={placeholder || undefined}
          identifierField="code"
          projectId={selectedProjectId || undefined}
          enabled={enabled}
          fetchOnlyOnOpen={fetchOnlyOnOpen}
        />
      </Box>
    </Tooltip>
  );
};

export default AgaveSubJobsDropdown;
